import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

export const getListOfDocumentsColumns = (
  t: TFunction,
  options: string[],
  renderDealerSignedDate?: (value: any, record: any) => React.ReactNode
): ColumnsType<any> =>
  options
    .filter((option) => option !== "icons")
    .map((option) => {
      if (option === "dealerSignedDate" && renderDealerSignedDate) {
        return {
          title: t(`registryOfDocs.${option}`),
          dataIndex: option,
          key: option,
          render: (value: any, record: any) =>
            renderDealerSignedDate(value, record),
        };
      }

      return {
        title: t(`registryOfDocs.${option}`),
        dataIndex: option,
        key: option,
      };
    });
